<template>
    <div>
        <!-- Header section -->
        <header class="header-section">
            <div class="container text-right">
                <div class="page-info">
                    <h2>Услуги</h2>
                    <div class="page-links">
                        <router-link to="/">Начало</router-link>
                        <span class="active">Услуги</span>
                    </div>
                </div>
            </div>
        </header>
        <div class="container mt-5">
            <div class="row">
                <div class="col-md-4">
                    <div class="mb-5">
                        <img :src="service.image" alt="" class="card-img-top mb-3">
                        <router-link v-if="userLogedIn" class="btn-lg btn-primary mt-3" :to="{name: 'editService', params: { id: $route.params.id }}">РЕДАКТИРАНЕ</router-link>
                    </div>
                </div>
                <div class="col-md-8">
                    <h2>{{ service.name }}</h2>
                    <p class="mt-4" v-html="service.description"></p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { db } from '../../firebase';

    export default {
        data() {
            return {
                service: {
                }
            }
        },
        computed: {
            userLogedIn () {
                return this.$store.getters.user
            }
        },
        created() {
            let dbRef = db.collection('services').doc(this.$route.params.id);
            dbRef.get().then((doc) => {
                this.service = doc.data();
            }).catch((error) => {
                console.log(error)
            })
        }
    }
</script>
